import styled from "styled-components";

const FileListWrap = styled.div`
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;

  .spin-box{
    margin-top: 40px;
  }

  .file-box{
    padding: 6px 4px;
    padding-right: 20px;
    border-radius: 8px;
    margin-top: 12px;
    border:1px solid #dedede;

    .name-box{

    }

  }
`;

export default FileListWrap;